import { render, staticRenderFns } from "./ItemListHomeArtLayout.vue?vue&type=template&id=0486e98a&scoped=true"
import script from "./ItemListHomeArtLayout.vue?vue&type=script&lang=js"
export * from "./ItemListHomeArtLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0486e98a",
  null
  
)

export default component.exports